import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { GlobalExclusionsBaseDataProvider } from '../dataProvider/GlobalExclusionsBaseDataProvider';

export class GlobalExclusionsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, GlobalExclusionsBaseDataProvider);
  }
}
